import FormTextField from '../../components/Form/FormTextField';
import { composeValidators, isValidEmail } from '../../components/Form/validations';

const formFieldData = [
  {
    ComponentType: FormTextField,
    fullWidth: true,
    label: 'Email',
    name: 'verificationType',
    required: true,
    validate: composeValidators(isValidEmail),
    mode: 'extraDark',
  },
];

export default formFieldData;
